import "./Benefits.css";

const left = [
  { icon: "🌾", title: "Langsung dari Pembudidaya", desc: "Kualitas tanaman terjamin langsung dari sumber." },
  { icon: "🌲", title: "Koleksi Lengkap", desc: "Berbagai jenis tanaman dari bibit hingga pohon besar." },
  { icon: "🛡️", title: "Garansi 3 Bulan", desc: "Proteksi retensi untuk proyek skala besar." },
  { icon: "💰", title: "Harga Terjangkau", desc: "Langsung dari petani, harga selalu kompetitif." },
];
const right = [
  { icon: "🚚", title: "Pengiriman Cepat & Aman", desc: "Tanaman tiba tepat waktu dan dalam kondisi prima." },
  { icon: "⭐", title: "Terpercaya", desc: "Dipercaya perusahaan besar dan instansi pemerintah." },
  { icon: "🗺️", title: "Kirim Se-Indonesia", desc: "Jangkauan proyek dan pengiriman seluruh Indonesia." },
  { icon: "💬", title: "Free Konsultasi", desc: "Konsultasi gratis tanpa batas waktu untuk semua klien." },
];

export default function Benefits() {
  return (
    <section className="benefits" id="keunggulan">
      <div className="container">
        <div className="benefits__head">
          <span className="eyebrow">Kenapa Kami</span>
          <h2 className="benefits__title">Kenapa Harus Pilih Kami?</h2>
          <p className="benefits__sub">Kami berkomitmen memberikan solusi penghijauan terbaik dengan kualitas premium.</p>
        </div>

        <div className="benefits__hub">
          {/* Left column */}
          <div className="benefits__col benefits__col--left">
            {left.map(b => (
              <div className="benefit-row benefit-row--rev" key={b.title}>
                <div className="benefit-row__icon">{b.icon}</div>
                <div className="benefit-row__text" style={{ textAlign: 'right' }}>
                  <h4>{b.title}</h4>
                  <p>{b.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Center photo */}
          <div className="benefits__center">
            <div className="benefits__center-img">
              <img
                src="https://images.unsplash.com/photo-1534710961216-75c88202f43e?q=80&w=688&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=500&auto=format&fit=crop"
                alt="Ahli taman Agrotani"
              />
            </div>
            <div className="benefits__center-badge">⭐ 1000+ Klien Puas</div>
          </div>

          {/* Right column */}
          <div className="benefits__col benefits__col--right">
            {right.map(b => (
              <div className="benefit-row" key={b.title}>
                <div className="benefit-row__icon">{b.icon}</div>
                <div className="benefit-row__text">
                  <h4>{b.title}</h4>
                  <p>{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="benefits__cta">
          <a href="#kontak" className="btn btn-green">Dapatkan Penawaran</a>
          <a href="#tentang" className="btn btn-outline-green">Pelajari Lebih Lanjut</a>
        </div>
      </div>
    </section>
  );
}
